import React, { Component } from "react";
import CustomLoader from "../../common/Loader";
import Dialog from "@material-ui/core/Dialog";
import DialogActions from "@material-ui/core/DialogActions";
import DialogContent from "@material-ui/core/DialogContent";
import DialogContentText from "@material-ui/core/DialogContentText";
import DialogTitle from "@material-ui/core/DialogTitle";
import { loadInfo, getRandomizedResult } from "../../../services/formService";
import { toaster } from "../../../config";

class RandomizeViewer extends Component {

    state = {
        Widget_ID: this.props.Widget_ID,
        Widget_Type_ID: this.props.Widget_Type_ID,
        PrimaryKey: this.props.PrimaryKey ? this.props.PrimaryKey : '', //TEST CASE: 10100100
        Project_ID: this.props.Project_ID ? this.props.Project_ID : 0,
        buttonColor: this.props.buttonColor ? 'btn-success' : 'btn-danger',
        confirm_dialog: false,
        result_dialog: false,
        randomize_result: '',
        Created_Date: null,
        SurveyMode: this.props.SurveyMode ? this.props.SurveyMode : false,
        label: 'This action cannot be undone. Are you sure to randomize this Participant?',
        buttonSuffix: '',
        loading: true

    };

    constructor(props) {
        super(props);
        this.handleConfirmDialog = this.handleConfirmDialog.bind(this)
        this.handleResultDialog = this.handleResultDialog.bind(this)
    }

    async componentDidMount() {
        const { data: InfoObj } = await loadInfo(this.state.Widget_ID);
        this.setState({ Display_Name: InfoObj.Info.Display_Name });
        if (this.state.SurveyMode && !(this.state.PrimaryKey === '')) { //Survey Mode
            const { data: loadRandomizeObj } = await getRandomizedResult(this.state.PrimaryKey, 'check');
            //console.log('loadRandomizeObj', loadRandomizeObj)
            if (!Object.keys(loadRandomizeObj).includes('None')) { //pk exists with assignment

                this.setState({
                    buttonColor: 'btn-danger',
                    buttonSuffix: 'Randomized by ' + loadRandomizeObj.Created_By + ' on ' + loadRandomizeObj['Created_Date'],
                    Display_Name: 'View Randomization Result',
                    randomize_result: loadRandomizeObj['assignment'],
                    label: 'This participant was randomized by User ' + loadRandomizeObj.Created_By + ' on ' + loadRandomizeObj['Created_Date'] + '. Are you sure to unblind the result?',
                    randomizeObj: loadRandomizeObj,
                    loading: false
                })
            }
            else { //pk exists with no assignment
                this.setState({ loading: false });
            }
        }
        else { //Preview Mode
            this.setState({
                buttonColor: 'btn-success',
                randomize_result: 'You are in Preview Mode! Participant\'s Randomization result will appear here.',
                loading: false
            })
        }
    }

    async handleConfirmDialog(val) {
        if (this.state.PrimaryKey === '') {
            this.setState({ confirm_dialog: false, result_dialog: false })
        }
        else if (val && this.state.SurveyMode && this.state.PrimaryKey) {
            if (this.state.randomizeObj !== undefined && this.state.randomizeObj['assignment']) {
                this.setState({
                    label: 'This participant was randomized by User ' + this.state.randomizeObj['Created_By'] + ' on ' + this.state.randomizeObj['Created_Date'] + '. Are you sure to unblind the result?',
                    buttonSuffix: 'Randomized by ' + this.state.randomizeObj['Created_By'] + ' on ' + this.state.randomizeObj['Created_Date'],
                });
            }
        }
        this.setState({ confirm_dialog: val })
    }

    async handleResultDialog(val) {
        //If pt. already randomized
        this.setState({ confirm_dialog: false })
        if (this.state.SurveyMode && this.state.PrimaryKey === '') {
            toaster('error', 'There\'s no participant to randomize. Please try again later!');
            this.setState({ result_dialog: false })
        }
        else if (this.state.SurveyMode && this.state.PrimaryKey) { //Survey Mode with a pk
            const { data: checkAgainRandomizeObj } = await getRandomizedResult(this.state.PrimaryKey, 'check');
            if (checkAgainRandomizeObj['assignment']) {
                this.setState({
                    buttonColor: 'btn-danger',
                    buttonSuffix: 'Randomized by ' + checkAgainRandomizeObj['Created_By'] + ' on ' + checkAgainRandomizeObj['Created_Date'],
                    Display_Name: 'View Randomization Result',
                    randomize_result: checkAgainRandomizeObj['assignment']
                })
            }
            else {
                const { data: randomizeObj } = await getRandomizedResult(this.state.PrimaryKey, 'generate');
                if (randomizeObj['assignment']) {
                    this.setState({
                        buttonColor: 'btn-danger',
                        buttonSuffix: 'Randomized by ' + randomizeObj['Created_By'] + ' on ' + randomizeObj['Created_Date'],
                        label: 'This participant was randomized by User ' + randomizeObj['Created_By'] + ' on ' + randomizeObj['Created_Date'] + '. Are you sure to unblind the result?',
                        Display_Name: 'View Randomization Result',
                        randomize_result: randomizeObj['assignment']
                    });
                    toaster('success', 'Randomize event success');
                }
                else {
                    this.setState({
                        randomize_result: 'Unable to Randomize participant at this time. Please try again later!'
                    })
                }
            }
            this.setState({ result_dialog: val })
        }
        else { //Preview Mode
            this.setState({ result_dialog: val, buttonColor: 'btn-danger', Display_Name: 'View Randomization Result' })
        }
    }

    render() {
        const { Display_Name, loading, buttonColor, confirm_dialog, result_dialog, randomize_result, label, buttonSuffix } = this.state;
        if (loading) {
            return <CustomLoader loading={this.state.loading} />;
        }
        return (
            <div>
                <button key={buttonColor} className={"btn " + buttonColor + " col-md-2 mb-2 mt-2 mr-2"} onClick={() => this.handleConfirmDialog(true)}>{Display_Name}</button>
                {buttonSuffix}
                {/* Confirm Dialog */}
                <Dialog
                    open={confirm_dialog}
                    fullWidth
                    aria-labelledby="alert-dialog-title"
                    aria-describedby="alert-dialog-description"
                >
                    <DialogTitle id="alert-dialog-title">Please confirm</DialogTitle>
                    <DialogContent>
                        <DialogContentText key={label} id="alert-dialog-description">
                            {label}
                        </DialogContentText>
                    </DialogContent>
                    <DialogActions>
                        <button className="btn btn-outline-primary rounded-0 btn-sm" onClick={() => this.handleResultDialog(true)}>
                            Yes
                        </button>
                        <button className="btn btn-outline-danger rounded-0 btn-sm" onClick={() => this.handleConfirmDialog(false)} autoFocus>
                            Cancel
                        </button>
                    </DialogActions>
                </Dialog>

                {/* Result Dialog */}
                <Dialog
                    open={result_dialog}
                    fullWidth
                    aria-labelledby="alert-dialog-title"
                    aria-describedby="alert-dialog-description"
                >
                    <DialogTitle id="alert-dialog-title">Randomization Result</DialogTitle>
                    <DialogContent>
                        <DialogContentText id="alert-dialog-description">
                            {randomize_result}
                        </DialogContentText>
                    </DialogContent>
                    <DialogActions>
                        <button className="btn btn-outline-primary rounded-0 btn-sm" onClick={() => this.handleResultDialog(false)}>
                            OK
                        </button>
                    </DialogActions>
                </Dialog>

            </div>
        );
    }
}

export default RandomizeViewer;